import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = { class: "flex mx-auto font-medium text-muted" }
const _hoisted_3 = { class: "mx-auto space-x-1" }
const _hoisted_4 = {
  key: 0,
  class: "hidden chip mx-auto chip-primary mb-0 pt-0.5"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-base mr-1 mt-1.25px" }, " update ", -1)
const _hoisted_6 = { class: "flex flex-col h-full" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "h-0 -mx-4 border-b md:-mx-5"
}
const _hoisted_9 = { class: "flex items-center mt-auto -mb-1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-lg material-icons-outlined" }, "update", -1)
const _hoisted_12 = {
  key: 1,
  class: "flex -mt-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timestamp = _resolveComponent("Timestamp")!
  const _component_ParticipationThumbnail = _resolveComponent("ParticipationThumbnail")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, {
      class: _normalizeClass({
				'md:h-23rem h-64': _ctx.showThumbnail,
				'h-44': !_ctx.showThumbnail,
			})
    }, {
      header: _withCtx(() => [
        (_ctx.participation.event.name.length > 0)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.participation.event.name), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createVNode(_component_Timestamp, {
              value: _ctx.participation.begin_timestamp,
              "date-only": true
            }, null, 8, ["value"])
          ]),
          (_ctx.isParticipable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("student_course_dashboard.pending")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.showThumbnail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_ParticipationThumbnail, { participation: _ctx.participation }, null, 8, ["participation"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showThumbnail)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.isParticipable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: {
									name: 'PublicPracticeParticipationPage',
									params: { slug: _ctx.slug, examId: _ctx.participation.event.id, courseId: _ctx.courseId },
								}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Btn, {
                        variant: "primary",
                        size: "sm"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("student_course_dashboard.resume")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.participation.assessment_available)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
									name: 'PublicPracticeSummaryPage',
									params: {
										slug: _ctx.slug,
										participationId: _ctx.participation.id,
										examId: _ctx.participation.event.id,
										courseId: _ctx.courseId,
									},
								}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Btn, {
                            size: "sm",
                            variant: "primary-borderless"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("student_course_dashboard.practice_summary")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["to"]))
                    : _createCommentVNode("", true)
                ])),
            (_ctx.showThumbnail)
              ? (_openBlock(), _createBlock(_component_Btn, {
                  key: 2,
                  tooltip: 
								_ctx.participation.bookmarked
									? _ctx.$t('student_course_dashboard.remove_bookmark')
									: _ctx.$t('student_course_dashboard.add_bookmark')
							,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('bookmark'))),
                  loading: _ctx.loading,
                  variant: "icon",
                  outline: "",
                  class: "my-0 ml-auto"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["material-icons", { 'text-primary': _ctx.participation.bookmarked }])
                    }, _toDisplayString(_ctx.participation.bookmarked ? "bookmark" : "bookmark_outline"), 3)
                  ]),
                  _: 1
                }, 8, ["tooltip", "loading"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}